<template>
  <div class="header mx-2">
    <div>{{ _t('atlas.level', { index: props.stageLevel }) }}</div>

    <Icon
      name="close-circle"
      class="cursor-pointer absolute right-0 top-0 w-22px"
      @click="onClose"
    ></Icon>
  </div>

  <div
    v-if="!loading && preStageInfo.packages.length === 0"
    class="flex greet justify-center items-center"
  >
    <Img name="ld-greet" />
    <div
      ref="chatBox"
      class="chat"
    >
      {{ _t('package.add_to_play') }}
    </div>
  </div>
  <div class="h-292px my-6">
    <Loading
      v-if="loading"
      class="h-full"
    />

    <Swiper
      v-else
      effect="coverflow"
      slidesPerView="auto"
      :centeredSlides="true"
      :grabCursor="true"
      :pagination="true"
      :coverflowEffect="{
        rotate: 0,
        stretch: 0,
        depth: 0,
        scale: 0.8,
        slideShadows: false,
      }"
      :modules="[EffectCoverflow]"
      @slideChange="onSlideChange"
      @swiper="onSetSwiper"
    >
      <SwiperSlide
        v-for="(item, index) in preStageInfo.packages"
        :key="item.id"
        class="w-232px h-292px"
      >
        <PackageCoverCard
          :package="item"
          :show-menu="false"
          :show-share="false"
          :selected="activeIndex === index"
          @click="onPkgClick(index)"
        />
      </SwiperSlide>

      <SwiperSlide class="w-232px h-288px">
        <div
          class="pkg-add"
          @click="onPkgAddSlideClick"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="89"
            height="88"
            viewBox="0 0 89 88"
            fill="none"
          >
            <path
              d="M47.1012 32.9997C47.1012 31.4809 45.87 30.2497 44.3512 30.2497C42.8325 30.2497 41.6012 31.4809 41.6012 32.9997L41.6012 41.2498H33.3512C31.8325 41.2498 30.6012 42.481 30.6012 43.9998C30.6012 45.5186 31.8325 46.7498 33.3512 46.7498H41.6012V54.9997C41.6012 56.5185 42.8325 57.7497 44.3512 57.7497C45.87 57.7497 47.1012 56.5185 47.1012 54.9997L47.1012 46.7498H55.3512C56.87 46.7498 58.1012 45.5185 58.1012 43.9998C58.1012 42.481 56.87 41.2498 55.3512 41.2498H47.1012V32.9997Z"
              fill="#43536C"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M44.5616 4.58301H44.1409C35.6768 4.58296 29.0436 4.58293 23.8682 5.27875C18.5708 5.99096 14.3907 7.47721 11.1097 10.7582C7.82877 14.0391 6.34252 18.2192 5.63031 23.5166C4.93449 28.692 4.93453 35.3252 4.93457 43.7892V44.2101C4.93453 52.6741 4.93449 59.3073 5.63031 64.4828C6.34252 69.7801 7.82877 73.9602 11.1097 77.2412C14.3907 80.5221 18.5708 82.0084 23.8682 82.7206C29.0436 83.4164 35.6768 83.4164 44.1409 83.4163H44.5616C53.0257 83.4164 59.6589 83.4164 64.8343 82.7206C70.1317 82.0084 74.3118 80.5221 77.5927 77.2412C80.8737 73.9602 82.36 69.7801 83.0722 64.4828C83.768 59.3073 83.768 52.6742 83.7679 44.21V43.7893C83.768 35.3252 83.768 28.6921 83.0722 23.5166C82.36 18.2192 80.8737 14.0391 77.5927 10.7582C74.3118 7.47721 70.1317 5.99096 64.8343 5.27875C59.6589 4.58293 53.0257 4.58296 44.5616 4.58301ZM14.9988 14.6473C17.0876 12.5585 19.9135 11.3599 24.601 10.7297C29.3676 10.0889 35.6311 10.083 44.3512 10.083C53.0714 10.083 59.3349 10.0889 64.1015 10.7297C68.7889 11.3599 71.6149 12.5585 73.7037 14.6473C75.7924 16.736 76.991 19.562 77.6212 24.2495C78.2621 29.016 78.2679 35.2795 78.2679 43.9997C78.2679 52.7198 78.2621 58.9833 77.6212 63.7499C76.991 68.4374 75.7924 71.2634 73.7037 73.3521C71.6149 75.4408 68.7889 76.6394 64.1015 77.2697C59.3349 77.9105 53.0714 77.9163 44.3512 77.9163C35.6311 77.9163 29.3676 77.9105 24.601 77.2697C19.9135 76.6394 17.0876 75.4408 14.9988 73.3521C12.9101 71.2634 11.7115 68.4374 11.0813 63.7499C10.4404 58.9833 10.4346 52.7198 10.4346 43.9997C10.4346 35.2795 10.4404 29.016 11.0813 24.2495C11.7115 19.562 12.9101 16.736 14.9988 14.6473Z"
              fill="#43536C"
            />
          </svg>
          <span class="font-size-21px mt-3 h-36px">
            {{ _t('package.add') }}
          </span>
        </div>
      </SwiperSlide>
    </Swiper>
  </div>

  <DebugLabel class="absolute top-0 left-0">
    <DebugButton
      v-if="pkg"
      label="完成关卡"
      size="small"
      @click="onDebugFinishStage"
    ></DebugButton>
  </DebugLabel>

  <div class="px-3">
    <div
      class="h-27px mb-2 flex justify-center items-center text-15px font-semibold gap-1"
    >
      <template v-if="pkg != null">
        <div v-if="isPkgTrailAllUsed(pkg)">
          {{ _t('package.trail_count_end') }}
        </div>

        <template v-else-if="isPassionateModeEnabled">
          <Icon
            name="crazy-mode"
            class="w-20px text-rose-500"
          />
          <span class="text-rose-500 font-semibold">
            {{ _t('package.passion_tip1') }}
          </span>
        </template>

        <ExpInfo
          v-else
          :exp="getPkgExp(pkg)"
        />
      </template>
    </div>

    <div class="min-h-54px">
      <template v-if="pkg != null">
        <Button
          v-if="!isPkgLearnable(pkg)"
          class="w-full h-60px"
          :label="_t('package.unlock')"
          @click="onPackageUnlock(pkg)"
        />

        <template v-else>
          <Button
            class="w-full h-60px"
            :scene="isPassionateModeEnabled ? 'passionate' : 'primary'"
            :loading="stageLoading"
            @click="onStageStart(pkg)"
          >
            <div
              class="flex justify-center w-full font-semibold items-center text-21px"
            >
              <span>{{ _t('package.start_challenge') }}</span>
              <EnergyCount
                v-if="!isPassionateModeEnabled"
                :count="preStageInfo.requiredEnergy"
                class="ml-4"
              />
            </div>
          </Button>

          <div
            v-if="store.isVipValid"
            class="w-full flex items-center justify-center mt-2 mb-1 gap-3"
          >
            <div
              :class="[
                'text-17px font-semibold',
                isPassionateModeEnabled ? 'text-rose-500' : 'text-gray',
              ]"
            >
              {{ _t('package.passion') }}
            </div>

            <Tooltip
              :show="showPassionateModeGuide"
              :z-index="passionateTooltipZindex"
              trigger="manual"
              placement="bottom"
            >
              <div class="text-17px font-semibold">
                {{ _t('package.passion_tip2') }}
              </div>
              <div class="text-17px">
                {{ _t('package.passion_tip3') }}
              </div>

              <template #trigger>
                <NSwitch
                  :value="store.passionateMode"
                  :rail-style="passionateSwitchRailStyle"
                  @update:value="onPassionateModeChange"
                />
              </template>
            </Tooltip>
          </div>
        </template>
      </template>

      <Button
        v-else-if="isAddPackage"
        class="w-full h-60px"
        :label="_t('package.add')"
        @click="onPkgAdd"
      ></Button>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { EffectCoverflow } from 'swiper/modules'
import type { Swiper as TSwiper } from 'swiper'
import 'swiper/css'
import { Code } from '@/api/code'
import { AtlasStageMode, preStartAtlasStage } from '@/api/atlas'
import { useCommonStore } from '@/stores/common-store'
import { useRoute, useRouter } from 'vue-router'
import { startAtlasStage } from '@/api/atlas'
import { getPackageShowDate } from '@/utils/package'
import { debugFinishStage } from '@/debug'
import EnergyCount from '@/components/EnergyCount.vue'
import { PackageAccess, type PackageBasic } from '@/api/package-source'
import ExpInfo from '@/components/ExpInfo.vue'
import Button from '@/components/Button.vue'
import PkgSearch from '@/components/pkg-search/PkgSearch.vue'
import PackageUnlock from '@/components/PackageUnlock.vue'
import { NSwitch } from 'naive-ui'
import zindexMgmt from '@/utils/zindexMgmt'
import { openPackageCreateDialog, showEnergyDialog } from '@/shared'
import PackageCoverCard from '@/components/business/package/PackageCoverCard.vue'
import type { OpenDialogPromise } from '@/types/global'
import PkgAddForm from '@/components/package/PkgAddForm.vue'

const store = useCommonStore()
const router = useRouter()
const route = useRoute()

const props = defineProps<{
  stageLevel: number
  /** 上一次选择的卡包 id，-1 表示滚动到添加卡包按钮的位置 */
  lastPkgId?: number
}>()

const emit = defineEmits<{
  stageCompleted: []
  /** 需要导航到其他页面，保存选择状态 */
  saveState: [pkgId?: number]
  done: [pkgId?: number]
}>()

const preStageInfo = ref<{
  packages: PackageBasic[]
  packageExpMap: Record<number, number>
  requiredEnergy: number
}>({
  packages: [],
  requiredEnergy: 0,
  packageExpMap: {},
})

const activeIndex = ref(0)
const loading = ref(true)
const stageLoading = ref(false)
const swiperController = ref<TSwiper>()
const showPassionateModeGuide = ref(false)

// 狂热模式的开启有两个条件，一个是在会员有效期内，一个是开启的狂热按钮
const isPassionateModeEnabled = computed(
  () => store.isVipValid && store.passionateMode
)

const passionateTooltipZindex = computed(() => {
  if (_global.isPcMode) return undefined

  return zindexMgmt.nextToastZIndex()
})

const pkg = computed<PackageBasic | undefined>(
  () => preStageInfo.value.packages[activeIndex.value]
)

const isAddPackage = computed(
  () =>
    activeIndex.value === preStageInfo.value.packages.length && !loading.value
)

async function initSwiperIndex() {
  // -1 表示滚动到添加卡包按钮的位置
  if (props.lastPkgId == -1) {
    activeIndex.value = preStageInfo.value.packages.length
    swiperController.value?.slideTo(activeIndex.value)
    return
  }

  const index = preStageInfo.value.packages.findIndex(
    pkg => pkg.id === props.lastPkgId
  )

  activeIndex.value = index > -1 ? index : 0
  swiperController.value?.slideTo(activeIndex.value)
}

function isPkgLearnable(pkg: PackageBasic) {
  if (pkg.packageAccess == null && pkg.trailStatus != null) {
    return pkg.trailStatus.trailCount < pkg.trailStatus.trailLimit
  }

  return true
}

function isPkgTrailAllUsed(pkg: PackageBasic) {
  if (pkg.packageAccess == null && pkg.trailStatus != null) {
    return pkg.trailStatus.trailCount >= pkg.trailStatus.trailLimit
  }

  return false
}

function getPkgExp(pkg: PackageBasic) {
  return preStageInfo.value.packageExpMap[pkg.id] ?? 0
}

function onSetSwiper(val: TSwiper) {
  swiperController.value = val
  initSwiperIndex()
}

function onSlideChange(swiper: TSwiper) {
  activeIndex.value = swiper.activeIndex
}

async function onDebugFinishStage() {
  if (!pkg.value) return

  const result = await debugFinishStage(pkg.value.id)

  if (result) {
    store.fetchStatsOverview()
    store.fetchEnergyStatus()
    _message.success('关卡已完成')
    emit('stageCompleted')
    emit('done', pkg.value.id)
  }
}

function onPackageUnlock(pkg: PackageBasic) {
  _presentContent(PackageUnlock, {
    rootClass: 'min-w-400px max-w-600px',
    props: {
      package: pkg,
      exitAfterUnlock: true,
      onUnlock(access: PackageAccess) {
        pkg.packageAccess = access
      },
    },
    dialog: {
      pt: {
        content: {
          style: 'padding: 0px;',
        },
      },
    },
  })
}

function onStageStart(pkg: PackageBasic) {
  if (stageLoading.value) return

  stageLoading.value = true

  startAtlasStage(
    pkg.id,
    isPassionateModeEnabled.value
      ? AtlasStageMode.PASSIONATE
      : AtlasStageMode.NORMAL
  )
    .then(async res => {
      if (res.code === Code.NotEnoughEnergy) {
        _message.info('面包不足')

        // 由于 tooltip 的 z-index 较高，所以这里当面包弹窗出现的时候先隐藏
        // 关闭面包弹窗时再显示
        const showGuide = showPassionateModeGuide.value
        showPassionateModeGuide.value = false
        showEnergyDialog(true).finally(() => {
          showPassionateModeGuide.value = showGuide
        })
        return
      } else if (res.code !== Code.Ok) {
        _message.info(res.message)
        return
      }

      store.increaseEnergy(-preStageInfo.value.requiredEnergy)

      store.setStageUnit(
        {
          unitId: res.data.unitId,
          atlasStageId: res.data.stageId,
          schedules: res.data.schedules,
        },
        pkg.cardType
      )

      emit('done', pkg.id)
      router.push({
        name: 'unit/learn',
        query: {
          packageId: pkg.id,
        },
      })
    })
    .finally(() => {
      stageLoading.value = false
    })
}

function onClose() {
  emit('done')
}

function onPkgAddSlideClick() {
  if (isAddPackage.value) {
    onPkgAdd()
  } else {
    onPkgClick(preStageInfo.value.packages.length)
  }
}

function onPkgClick(index: number) {
  activeIndex.value = index
  swiperController.value?.slideTo(activeIndex.value)
}

function onPkgAdd() {
  _presentContent(PkgAddForm, {
    rootClass: 'w-480px',
    props: {
      onDiscover: async () => {
        if (_global.isPcMode) {
          showPkgSearchDialog()
        } else {
          await router.replace({
            query: {
              ...route.query,
              pkgId: -1,
            },
          })
          router.push({ name: 'pkg-search' })
        }
      },
      onCreate: () =>
        openPackageCreateDialog({
          onCreate(pkg: PackageBasic) {
            router.push({ name: 'package', params: { id: pkg.id } })
          },
        }),
    },
    dialog: {
      pt: {
        content: {
          style: 'padding: 0px;',
        },
      },
    },
  })
}

let searchDialog: OpenDialogPromise<void> | undefined
async function showPkgSearchDialog() {
  if (searchDialog != null) return

  searchDialog = _openDialog(PkgSearch, {
    props: {
      isPage: false,
      navigator: 'modal',
      onPackageChallenge(pkgId: number) {
        router.push({
          name: 'atlas',
          query: {
            pkgId,
          },
        })
      },
    },
    dialog: {
      contentClass: 'bg-[var(--surface-hover)] ',
      showHeader: false,
      pt: {
        content: {
          style: 'padding: 0px;',
        },
      },
    },
    rootClass: 'w-1024px mx-10 h-[80vh] min-w-[480px] min-h-[480px]',
  })
  searchDialog.then(() => {
    searchDialog = undefined
  })
}

async function fetchUserPackages() {
  loading.value = true
  try {
    const res = await preStartAtlasStage(props.stageLevel)

    preStageInfo.value.requiredEnergy = res.requiredEnergy
    preStageInfo.value.packages = res.packageList.packages.sort(
      (a, b) => getPackageShowDate(b) - getPackageShowDate(a)
    )
    preStageInfo.value.packageExpMap = res.expMap

    initSwiperIndex()
  } finally {
    loading.value = false
  }
}

function passionateSwitchRailStyle({ checked }: { checked: boolean }) {
  return {
    boxShadow: 'none',
    backgroundColor: checked ? 'var(--rose-500)' : 'var(--ld-switchSecondary)',
  }
}

function onPassionateModeChange(val: boolean) {
  store.setAtlasLearnMode(val)

  // 如果开启了狂热模式且此时正在提示引导信息，则表示引导完成
  if (val && showPassionateModeGuide.value) {
    showPassionateModeGuide.value = false
    store.completePassionateModeGuide()
  }
}

onMounted(async () => {
  await fetchUserPackages()

  const currentEnergy = store.energy?.currentEnergy ?? 0

  // if （面包不足以完成一个关卡）&（未开启狂热学习开关）&（免费补充面包次数已用完）&（未完成过狂热学习引导提示）：
  // 显示气泡引导提示
  if (
    isPassionateModeEnabled.value &&
    currentEnergy < preStageInfo.value.requiredEnergy &&
    store.vipEnergyFreeTimes === 0 &&
    !store.isPassionateModeGuideCompleted
  ) {
    showPassionateModeGuide.value = true
  }
})
</script>

<style scoped>
.header {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  position: relative;
  height: 24px;
  margin-top: 12px;
}

.pkg-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #fff;
  box-shadow: var(--ld2-button-shadow-netural-large);
  border-radius: 16px;
  height: 100%;
  width: 100%;

  /* 禁止用户选中 */
  user-select: none;
  -webkit-user-select: none;
}

.greet :deep(img) {
  width: 77px;
}

.greet .chat {
  background-color: white;
  border-radius: 18px;
  font-size: 17px;
  line-height: 22px;
  padding: 12px 16px;
  height: fit-content;
  animation: chatScale 0.15s;
  animation-fill-mode: forwards;
  white-space: nowrap;
}
</style>
